import { Result, Spin } from "antd";
import ImportantNotes from "components/auth/ImportantNotes";
import PageLayout from "pages/auth/page-layout";
import { useEffect, useState } from "react";
import { useAppSelector } from "redux/hooks";

const Maintenance: React.FC = () => {
  const [isSpin, setIsSpin] = useState<boolean>(true);
  const properties = useAppSelector(state => state.properties.data);
  const isPropertiesEmpty = !properties || Object.keys(properties).length === 0;

  useEffect(() => {
    setTimeout(() => {
      setIsSpin(false);
    }, 1000);
  }, []);

  return (
    <PageLayout isSingleCard={true}>
      {isSpin ? (
        <div className="center-content">
          <Spin size="large" />
        </div>
      ) : isPropertiesEmpty ? (
        <div style={{ width: "100%" }}>
          <Result status="warning" title="Closed for Maintenance" />
        </div>
      ) : (
        <ImportantNotes properties={properties} isResponsive={false} />
      )}
    </PageLayout>
  );
};

export default Maintenance;
